export const apis = {
  login: `/api/auth/v1/login?otp=true&source=LOGIN`,
  logout: `/api/auth/v1/logout`,
  forgotPassword: `/api/user/v1/forgotPassword`,
  resetPassword: `/api/user/v1/resetPassword`,
  changePassword: `/api/user/v1/changePassword`,
  profile: `/api/user/v2/profile`,
  notifications: "/api/admin/notifications/v1",
  update_notification: "/api/admin/notifications/v1/update",
  dashboard: `/api/admin/dashboard/v1`,
  inquiry: "/api/v1/inquiry",
  enableCardLimit: "/api/admin/cards/enable_card_limit", // pending
  enableTxnType: "/api/admin/cards/v1/enableTransactionType",
  cardPolicies: "/api/admin/cards/v1/fetchData",
  cardLimitSet: "/api/admin/cards/v1/setBulkCardLimit",
  cardPoliciesNLimits: "/api/admin/cards/v1/fetchCardPolicies",
  cardLimit: "/api/admin/cards/v1/listCardLimits",
  qucikLoad: "/api/admin/cards/v1/quickTransferTopup",
  userLogs: "/api/user/v1/approvalLogs",
  export_approval_logs: "/api/user/v1/exportApprovalLogs",
  show_card_policy: "/api/admin/cards/v1/fetchCardPolicyById",
  advanceShow: "/api/advances/v1/show",
  reports: `/api/admin/reports/v1/list`,
  reportsReject: `/api/admin/reports/v1/reject`,
  reportsApprove: `/api/admin/reports/v1/approve`,
  reportsApproveBulk: `/api/admin/reports/v1/bulk-approve`,
  reportsRejectBulk: `/api/admin/reports/v1/bulk-reject`,
  reportsReimburse: `/api/admin/reports/v1/reimburse`,
  reportsComments: `/api/reports/v1/comments`,
  reportsHistory: `/api/reports/v1/history`,
  reportsAdvance: `/api/admin/advances/v1/list`,
  reportsExportExcel: `/api/admin/reports/export?format=csv`, // need to check with backend
  reportDetailsPDF: "/api/admin/reports/v1/export-report-details",
  showReport: "/api/admin/reports/v1/show",

  userReports: `/api/reports/v1`,
  userReportSubmit: `/api/reports/v1/submit`,
  userReportRecall: `/api/reports/v1/recall`,
  userReportFields: `/api/reports/v1/report_fields`,
  userReportLinkExp: `/api/reports/v1/link-transactions`,
  userReportLinkAdv: `/api/reports/v1/link-advances`,
  userReportsComments: `/api/reports/v1/comments`,
  userReportsHistory: `/api/reports/v1/history`,
  userReportsAdvance: `/api/advances/v1`,
  userShowReport: "/api/admin/reports/v1/show",
  userReportsExportExcel: `/api/reports/export?format=csv`, // need to check with backend

  trips: `/api/admin/trips/v1/list`,
  userTrips: `/api/trips/v1`,
  userTripRecall: `/api/trips/v1/recall`,
  userTripCancel: `/api/trips/v1/cancel`,
  userTripsSubmit: `api/trips/v1/submit`,
  userTripFields: `/api/trips/v1/fieldTrips`,
  userTripLinkReport: `/api/reports/v1/link-trips`,
  tripsReject: `/api/admin/trips/v1/reject`,
  tripsApprove: `/api/admin/trips/v1/approve`,
  tripsComments: `/api/trips/v1/comments`,
  tripsHistory: `/api/admin/trips/v1/history`,
  tripsShow: `/api/admin/trips/v1/show`, // need to check with backend
  tripClose: `/api/admin/trips/v1/close`,
  download_trip_attachments: "/api/admin/trips/v1/download-trip-attachments",
  attach_trip_file: "/api/admin/trips/v1/attach-trip-files",
  remind_card_activation: "/api/admin/cards/v1/remind-card-activation",
  expenseComments: "/api/admin/transactions/v1/comments",
  userTripsComments: `/api/trips/v1/comments`,
  userTripsHistory: `/api/trips/v1/history`, // java api is not present in the url excel

  advances: `/api/admin/advances/v1/list`,
  advancesReject: `/api/admin/advances/v1/reject`,
  advancesApprove: `/api/admin/advances/v1/approve`,
  advancesComments: `/api/advances/v1/comments`,
  advancesHistory: `/api/advances/v1/history`,
  advancesExportExcel: `/api/admin/advances/export?format=csv`, // need to check with backend

  userAdvances: `/api/advances/v1`,
  updateUserAdvances: `/api/advances/v1/update`,
  userAdvancesSubmit: `/api/advances/v1/submit`,
  userAdvancesRecall: `/api/advances/v1/recall`,
  userAdvancesComments: `/api/advances/v1/comments`,
  userAdvancesHistory: `/api/advances/v1/history`,
  unlinkAdvance: `/api/advances/v1/unlink`,

  userCards: `/api/cards/v1`,
  blockReasons: `/api/cards/v1/blockReason`,
  cards: `/api/admin/cards/v1/list`,
  transfers: "/api/staff/v1/transfers",
  savePendingRecords: "/api/staff/transfers/v1/savePendingRecords",
  getPendingRecords: "/api/staff/transfers/v1/getPendingRecords",
  transfersReject: "/api/staff/transfers/v1/reject",
  transfersRejectV2: "/api/staff/transfers/v2/reject",
  transfersBluk: "/api/staff/v1/bulkUploads?type=topup",
  transfersBlukShow: "/api/staff/v1/bulkUploads/show",
  cardsDetails: `/api/admin/cards/v1/details`,
  cardTransactions: `/api/admin/transactions/v1/list`,
  topup: `/api/admin/cards/v1/topup`,
  block: `/api/admin/cards/v1/block`,

  categories: `/api/admin/categories/v1/`,
  categoriesStatus: `/api/admin/categories/v1/changeStatus`,
  deleteCategories: `/api/admin/categories/v1/delete`,

  employees: `/api/admin/employees/v1`,
  usersList: "/api/staff/users/v1/list",
  updateEmployees: `/api/admin/employees/v1/update`,
  getCustomFields: `/api/admin/employees/v1/custom-fields`,

  companySetting: `/api/admin/company-settings/v1/show`,
  companyCountries: `/api/admin/countries/v1`,
  companyStates: `/api/admin/states/v1`,
  companyCities: `/api/admin/cities/v1`,

  reportApprovals: `/api/admin/report-approvals/v1/show`,
  updateReportApprovals: `/api/admin/report-approvals/v1/save`,

  advanceApprovals: `/api/admin/advance-approvals/v1/show`,
  updateAdvanceApprovals: `/api/admin/advance-approvals/v1/save`,

  tripApprovals: `/api/admin/trip-approvals/v1/show`,
  updateTripApprovals: `/api/admin/trip-approvals/v1/save`,

  updateTransaction: `/api/admin/company-settings/v1/createExpense`,
  transactionField: `/api/admin/transactionFields/v1`,
  deleteTransactionField: `/api/admin/transactionFields/v1/delete`,
  updateTransactionField: `/api/admin/transactionFields/v1/update`,

  updateReport: `/api/admin/company-settings/v1/createReport`,
  reportField: `/api/admin/report-fields/v1`,
  deleteReportField: `/api/admin/report-fields/v1/delete`,
  updateReportField: `/api/admin/report-fields/v1/update`,
  getReportTransactionField: `/api/admin/transactions/v1/list`,
  getReportTransactionComments: `/api/transactions/v1/comments`,

  updateCompAdvances: `/api/admin/company-settings/v1/createAdvance`,
  advancesField: `/api/admin/advance-fields/v1`,
  deleteAdvancesField: `/api/admin/advance-fields/v1/delete`,
  updateAdvancesField: `/api/admin/advance-fields/v1/update`,

  updateTrips: `/api/admin/company-settings/v1/create-trips`,
  tripsField: `/api/admin/trip-fields/v1`,
  deleteTripsField: `/api/admin/trip-fields/v1/delete`,
  updateTripsField: `/api/admin/trip-fields/v1/update`,
  unlinkTrips: `/api/trips/v1/unlink`,
  costCenterField: `/api/admin/cost-centers/v1`,
  deleteCostCenterField: `/api/admin/cost-centers/v1/delete`,
  updateCostCenterField: `/api/admin/cost-centers/v1/update`,

  merchantsField: `/api/admin/transaction-merchants/v1`,
  deleteMerchantsField: `/api/admin/transaction-merchants/v1/delete`,
  updateMerchantsField: `/api/admin/transaction-merchants/v1/update`,

  projectsField: `/api/admin/projects/v1`,
  deleteProjectsField: `/api/admin/projects/v1/delete`,
  updateProjectsField: `/api/admin/projects/v1/update`,

  companyProfile: `/api/admin/companies/v1/show`,
  updateCompanyProfile: `/api/admin/companies/v1/update`,

  rolesPermissions: `/api/admin/roles/v1/permissions`,
  ccrolesPermissions: `/api/admin/roles/v1/cc-permissions`, //java api is not present in the url excel
  roles: `/api/admin/roles/v1/save`,
  getRoles: `/api/admin/roles/v1`,
  getSingleRoles: `/api/admin/roles/v1/show`,

  getUserFields: `/api/admin/employeeFields/v1`,
  updateUserFields: `/api/admin/employeeFields/v1/update`,
  getSingleUserFields: `/api/admin/employeeFields/v1/fetchById`,
  deleteUserFields: `/api/admin/employeeFields/v1/delete`,
  userFieldsColumns: `/api/admin/employee_fields/column_types`, // java api is not present in the url excel

  transactions: `/api/admin/transactions/v1/list`,
  transactionsLinkReport: `/api/admin/transactions/link_report`, // java api is not present in the url excel
  updateTransactions: `/api/admin/transactions/update`, // java api is not present in the url excel
  deleteTransactions: `/api/transactions/v1/delete`,
  getTransactionsFields: `/api/admin/transactions/transaction_fields`, // java api is not present in the url excel
  transactionsReject: `/api/admin/transactions/v1/reject`,
  transactionsUnlink: `/api/transactions/v1/unlink`,
  transactionsHistory: `/api/transactions/v1/history`,
  transactionsPartialApprove: `/api/admin/transactions/v1/partialApprove`,
  txnsAttachments: `/api/transactions/v1/show-attachments`,

  // advances: `/api/admin/advances/list`,
  getSingleAdvances: `/api/admin/advances/v1/show`,
  updateAdvances: `/api/admin/advances/update`, // java api is not present in the url excel
  deleteAdvances: `/api/admin/advances/delete`, // java api is not present in the url excel
  getAdvancesFields: `/api/admin/advances/advance_fields`, // java api is not present in the url excel

  userAdvanceFields: `/api/advances/v1/advance-fields`,
  userAdvanceDelete: `/api/advances/v1/delete`,

  designations: `/api/admin/designations/v1`,
  getSingleDesignations: `/api/admin/designations/v1/fetchById`,
  updateDesignations: `/api/admin/designations/v1/create`,
  deleteDesignations: `/api/admin/designations/v1/delete`,
  deleteRole: "/api/admin/roles/v1/delete",
  userTransactions: `/api/transactions/v1`,
  userUpdateTransactions: `/api/transactions/v1/update`,
  userTransactionsFields: `/api/transactions/v1/transaction-fields`,
  getUserTransactionComments: `/api/transactions/v1/comments`,
  userTransactionsHistory: `/api/transactions/v1/history`,
  report_counts: "/api/dashboard/v1",
  downloadBulk: "/api/admin/cards/v1/bulkTopupFieldsTemplate",
  uploadBulk: "/api/admin/cards/v1/importBulkTopup",
  replacement: "/api/admin/cards/v1/replacement",
  corporate_budget: "/api/admin/cards/v1/corporateBudget",
  tranferlog: "/api/admin/cards/v1/importTopupFileStatus",
  userFields: "/api/admin/employees/v1/importUserFields",
  importUserTemplate: "/api/admin/employees/v1/importTemplate",
  uploadUsers: "/api/admin/employees/v1/import",
  analytics_cards: "/api/admin/transactions/v1/transactionReport",
  analytics_reports: "/api/admin/reports/v1/analytics-report",
  txn_card_export: "/api/admin/transactions/v1/export-pdf",
  txn_report_export: "/api/admin/reports/v1/export-pdf-csv",
  analytics_advances_export: "/api/admin/advances/v1/export-csv-pdf",
  analytics_advances: "/api/admin/advances/v1/analytics-advance-reports",
  analytics_expenses: "/api/admin/transactions/v1/analytics-expenses",
  analytics_trips: "/api/admin/trips/v1/analytics-trips",
  analytics_trips_export: "/api/admin/trips/v1/export-analytics-trips",
  analytics_expenses_export:
    "/api/admin/transactions/v1/export-analytics-expenses",
  export_advance_details: "/api/admin/advances/v1/export-advance-details",
  export_trip_details: "/api/admin/trips/v1/export-trips-details",
  update_trip: "api/trips/v1/update", // for update, submit and delete using /api/trips/v1/ need to check with backend
  create_expense_policy: "/api/admin/transactions/v1/create-expense-policy",
  list_expense_policies: "/api/admin/transactions/v1/fetchAllExpensePolicies",
  edit_expense_policy: "api/admin/transactions/v1/update-expense-policy", // java api is not present in the url excel
  delete_expense_policy: "/api/admin/transactions/v1/delete-expense-policy",
  show_expense_policy: "/api/admin/transactions/v1/show-expense-policy", // java api is not present in the url excel
  fetch_expense_policy_data: "api/admin/transactions/v1/fetchExpensePolicyData",
  accountTxns: "/api/admin/cards/v1/budget-credit-transaction",

  updateUserReport: "/api/reports/v1/update",
  cardPolicyDelete: "/api/admin/cards/v1/deleteCardPolicy",
  // setCardLimit: "/api/admin/cards/set_card_limit",
  get_card_limit_per_txn: "/api/admin/cards/v1/getCardLimitPerTxn",
  setCardLimit: "/api/admin/cards/v1/setCardLimitPerTxn",
  tripsDelete: `/api/trips/v1/delete`, // for update, submit and delete using /api/trips/v1/ need to check with backend
  set_pin: "/api/cards/v1/setPin",
  payment_gateway: "/api/cards/v1/paymentGateway",
  send_otp: "/api/cards/v1/sendOtp",
  verify_otp: "/api/cards/v1/verifyOtp",
  activate: "/api/admin/cards/v2/activate",
  activate_v1: "/api/admin/cards/v1/activate",
  update_mobile_number: "/api/cards/v1/updateMobileNumber",
  confirm_email: "/api/user/confirm_email", // java api is not present in the url excel
  validate_expense: "/api/transactions/v1/validateExpensePolicy",
  bulk_expenses: "/api/transactions/create_bulk_transactions", // java api is not present in the url excel
  cardsTransferAPI: "/api/cards/v1/walletToWalletTransfer",
  fundTransferAPI: "/api/cards/v1/fundTransfer",
  // batch apis
  report_pdf_from_batch: "/api/admin/reports/v1/reportPdfFromBatch",
  trip_pdf_from_batch: "/api/admin/trips/v1/trip-pdf-from-batch",
  expenses_pdf_from_batch: "/api/admin/transactions/v1/expenses-pdf-from-batch",
  advances_pdf_from_batch: "/api/admin/advances/v1/advance-pdf-from-batch",
  cards_pdf_from_batch:
    "/api/admin/transactions/v1/analytics-expenses-pdf-from-batch",

  // otps
  generateOTP: "/api/otps/generate", // java api is not present in the url excel
  resendOTP: "/api/otps/v1/resend",
  verifyOTP: "/api/otps/v1/verify",

  // disputes
  disputes: "/api/admin/disputes/v1",
  update_disputes: "/api/disputes/update", // need to check with backend
  dispute_comments: "/api/disputes/v1/comments",
  credit_transactions_pdf: "/api/admin/cards/v1/export-budget-credit-transactions",
  getBeneficiaryAPI: "/api/admin/beneficiaries/v1/list",
  createBeneficiaryAPI: "/api/admin/beneficiaries/v1",
  updateBeneficiaryAPI: "/api/beneficiaries/update", // need to check with backend
  getByIDBeneficiaryAPI: "/api/beneficiaries/show", // need to check with backend
  quickDataDownloadAPI: "/api/admin/cards/v1/export-quick-transfer-topup-status",
  bulkDataDownloadAPI: "/api/admin/cards/v1/exportBulkTransferTopupStatus",
  export_transactions: "/api/admin/transactions/v1/export-transactions",
  disputeHistories: "/api/disputes/v1/histories",
  set_mb_pin: "/api/cards/v1/set-mb-pin",
  card_pin_set: "/api/cards/v1/card-pin-set",
  pinset_resend_otp: "/api/cards/v1/pinset-resend-otp",
  get_card_sensitive_data: "/api/cards/v1/getCardSensitiveData",
};
